import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SvgFixService {
  fixSvgUse(delay: number = 100): void {
    const embed = (parent: Element, svg: SVGSVGElement, target: Element | null, use: SVGUseElement) => {
      if (!target) return;

      if (!svg.hasAttribute('viewBox') && target.getAttribute('viewBox')) {
        svg.setAttribute('viewBox', target.getAttribute('viewBox')!);
      }

      const clone = target.cloneNode(true);
      const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');

      Array.from(clone.childNodes).forEach(child => {
        g.appendChild(child.cloneNode(true));
      });

      Array.from(use.attributes).forEach(attr => {
        if (attr.name !== 'xlink:href' && attr.name !== 'href') {
          g.setAttribute(attr.name, attr.value);
        }
      });

      parent.appendChild(g);
    };

    const processUse = (use: SVGUseElement) => {
      const svg = use.closest('svg');
      const parent = use.parentNode as Element;
      const src = use.getAttribute('xlink:href') || use.getAttribute('href');
      if (!src || !svg || !parent) return;

      const [url, id] = src.split('#');
      if (url) {
        fetch(url)
          .then(res => res.text())
          .then(text => {
            const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
            const target = doc.getElementById(id);
            embed(parent, svg, target, use);
          }).catch(error => {
            console.warn('Failed to load SVG resource:', url, error);
            const target = document.getElementById(id);
            if (target) {
              embed(parent, svg, target, use);
            }
          });
      } else {
        const target = document.getElementById(id);
        embed(parent, svg, target, use);
      }

      if (parent.contains(use)) parent.removeChild(use);
    };
    
    setTimeout(() => {
      const uses = document.querySelectorAll<SVGUseElement>('use');
      uses.forEach(processUse);
    }, delay);
  }
}
